import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	anyLozengeTextNonFinal: {
		id: 'accessible-workflow-diagram.diagram.global-loop-transition.any-lozenge-text-non-final',
		defaultMessage: 'Any',
		description:
			'Message that indicates this transition can be used from "Any" status in the workflow. This is identical to the "Any" lozenge in Global Transitions.',
	},
});
